/**
 * Determine whether a user has a unique username.
 *
 * @param param0 User-like record.
 * @returns Whether the user has a unique username.
 */
export function hasUniqueUsername<T extends {discriminator: string}>({discriminator}: T): boolean {
  return discriminator === '0';
}
